import React from "react";
import { useDispatch } from "react-redux";
import { setCarts } from "../../store/actions/productAction";

const CartItem = ({ cart, checkoutPage }) => {
  const dispatch = useDispatch();

  const { productId } = cart;

  const updateCart = (e) => {
    const cartItem = {
      productId,
      qty: e.target.value,
    };
    dispatch(setCarts(cartItem, "update"));
  };

  return (
    <div id="cart-item">
      <div className="card mb-1">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            <img
              src={cart.product.image}
              className="img-fluid rounded-start ms-4"
              alt="..."
            />
          </div>
          <div className="col-lg-9 col-md-8 col-sm-6 col-xs-6">
            <div className="card-body mt-3">
              <div className="top d-flex justify-content-between">
                <div>
                  <h5 className="card-title">{cart.product.name}</h5>
                  <p className="card-text text-muted">
                    {cart.product.category}
                  </p>
                </div>
                <div>
                  <p className="fs-5 ms-2">₹{cart.product.cost}</p>
                </div>
              </div>
              <div>
                <input
                  type="number"
                  value={cart.qty}
                  className="form-control float-end"
                  onChange={updateCart}
                  disabled={checkoutPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
